// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3018": "bdf618ba","3574": "b04d55ee","8688": "f395bd34","8966": "e505230b",}[chunkId] + ".css"
}